import { GridColDef } from '@mui/x-data-grid';
import MuiDataGrid from 'components/MuiDataGrid';
import useI18n from 'hooks/useI18n';
import { TGender, TPublic } from './api/type';
import { IAdminPatients } from './api/type';

interface Props {
  list: IAdminPatients[];
  isLoading: boolean;
  totalCount: number;
  page: number;
  selected: string[];
  onSelected: (value: string[]) => void;
  onPageChange: (page: number) => void;
}

function ListBody(props: Props) {
  const i18n = useI18n();
  const {
    list,
    isLoading,
    totalCount,
    page,
    onPageChange,
    onSelected,
    selected,
  } = props;

  const columns: GridColDef[] = [
    { field: 'patient_id', headerName: 'Виртуал Өвчтөний ID' },
    { field: 'name', headerName: 'Виртуал Өвчтөний Нэр', minWidth: 200 },
    { field: 'age', headerName: 'Нас' },
    {
      field: 'gender',
      headerName: 'Хүйс',
      valueFormatter: ({ value }: { value: TGender }) =>
        i18n(`GENDER.${value}`),
    },
    { field: 'department', headerName: 'Тасаг' },
    { field: 'ward', headerName: 'Тасалгаа' },
    { field: 'disease_main', headerName: 'Үндсэн Оношлогооны Код' },
    {
      field: 'patient_private',
      headerName: 'Оюутны ENR Харагдах Байдал',
      valueFormatter: ({ value }: { value: TPublic }) =>
        i18n(`PUBLIC.${value}`),
    },
  ];

  return (
    <MuiDataGrid
      columns={columns}
      loading={isLoading}
      onPageChange={onPageChange}
      onSelectionModelChange={models => {
        onSelected(models as string[]);
      }}
      page={page}
      pageSize={20}
      rows={list.map(item => ({ ...item, id: item.patient_id }))}
      rowCount={totalCount}
      selectionModel={selected}
    />
  );
}

export default ListBody;
